import api from './api';

// Authenticated blob download (same pattern as analysisApi.downloadReport —
// a plain <a href> has no Authorization header and 401s).
async function downloadBlob(path, filename) {
  const res = await api.get(path, { responseType: 'blob' });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export const toolkitApi = {
  getCategories: () => api.get('/v1/toolkit/categories').then((r) => r.data),
  getContact: () => api.get('/v1/toolkit/contact').then((r) => r.data),
  putContact: (contact) => api.put('/v1/toolkit/contact', contact).then((r) => r.data),
  generate: (payload) => api.post('/v1/toolkit/generate', payload).then((r) => r.data),
  listMessages: () => api.get('/v1/toolkit/messages').then((r) => r.data),
  getMessage: (id) => api.get(`/v1/toolkit/messages/${id}`).then((r) => r.data),
  updateMessage: (id, patch) => api.patch(`/v1/toolkit/messages/${id}`, patch).then((r) => r.data),
  deleteMessage: (id) => api.delete(`/v1/toolkit/messages/${id}`).then((r) => r.data),
  getEmailText: (id) => api.get(`/v1/toolkit/messages/${id}/email-text`).then((r) => r.data.text),
  downloadDocx: (id) => downloadBlob(`/v1/toolkit/messages/${id}/docx`, `written-request-${id}.docx`),
};
